import Chevron from 'src/components/dashboard/components/navigationMenu/components/chevron';
import React from 'react';
import { ServiceLoanerTableData } from 'src/services/models/service-loaner.service';
import { useLocalization } from 'src/utils/useLocalization';
import './style.scss';

export interface ITableContents {
    items: ServiceLoanerTableData[];
    onClick: (vin: string, accountNumber: number) => void;
    forPrint: boolean;
    hideSortArrows?: boolean;
}

export interface Props {
    data: ServiceLoanerTableData;
    onClick: (vin: string, accountNumber: number) => void;
}

const statusStrings: { [key: string]: string } = {
    ORANGE: 'Beyond Term',
    GREEN: 'Active Lease',
    YELLOW: 'At Maturity',
    RED: 'Force Ground',
};

export const TableItem = (props: Props) => {
    const { inventoryTable } = useLocalization();
    const { vin, model, status, maturityDate, price, accountNumber } =
        props.data;

    return (
        <div className='sl-table-row'>
            <div className='table-row col-1'>
                <span className='list-label'>{inventoryTable.VIN}</span>
                <span
                    className='underline'
                    onClick={() => props.onClick(vin, accountNumber)}
                >
                    {vin}
                </span>
            </div>
            <div className='table-row col-2'>
                <span className='list-label'>{inventoryTable.VEHICLE}</span>
                <span>{model}</span>
            </div>
            <div className='table-row col-3'>
                <span className='list-label'>{inventoryTable.STATUS}</span>
                <div className='status'>
                    <span className={`dot dot-${status?.toLowerCase()}`}></span>
                    <span className='dot-label'>{statusStrings[status]}</span>
                </div>
            </div>
            <div className='table-row col-4'>
                <span className='list-label'>
                    {inventoryTable.MATURITY_DATE}
                </span>
                {maturityDate}
            </div>
            <div className='table-row col-5'>
                <span className='list-label'>
                    {inventoryTable.PURCHASE_PRICE}
                </span>
                <span>
                    $
                    {price.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                    })}
                </span>
            </div>
        </div>
    );
};

export const Table = React.forwardRef((props: ITableContents, ref: any) => {
    const { inventoryTable } = useLocalization();
    const sortArrow = !props.hideSortArrows ? (
        <span>
            <Chevron
                className='accordion__icon rotate-down'
                width={10}
                fill='#363b49'
            />
        </span>
    ) : null;
    return (
        <div className={`sl-table ${props.forPrint ? 'print' : ''}`} ref={ref}>
            <div className='sl-table-row header-row hidden-in-list'>
                <div className='table-header col-1'>
                    <span className='u-text-truncate'>
                        {inventoryTable.VIN}
                    </span>
                    {sortArrow}
                </div>
                <div className='table-header col-2'>
                    <span className='u-text-truncate'>
                        {inventoryTable.VEHICLE}
                    </span>
                    {sortArrow}
                </div>
                <div className='table-header col-3'>
                    <span className='u-text-truncate'>
                        {inventoryTable.STATUS}
                    </span>
                    {sortArrow}
                </div>
                <div className='table-header col-4'>
                    <span className='u-text-truncate'>
                        {inventoryTable.MATURITY_DATE}
                    </span>
                    {sortArrow}
                </div>
                <div className='table-header col-5'>
                    <span className='u-text-truncate'>
                        {inventoryTable.PURCHASE_PRICE}
                    </span>
                    {sortArrow}
                </div>
            </div>
            {props.items.map((item, index) => (
                <TableItem key={index} data={item} onClick={props.onClick!} />
            ))}
        </div>
    );
});

Table.displayName = 'Table';

export default Table;
